// extracted by mini-css-extract-plugin
module.exports = {"fallback":"Visualizer_fallback__df-8F"};